module.exports = __webpack_public_path__ + "images/admin/percy-performance-pulse.png";